// react
import { useMemo } from 'react';

// tanstack
import { useNavigate } from '@tanstack/react-router';

// material ui
import { DataGridPremium } from '@mui/x-data-grid-premium';

// shared components
import EnergyGroupTypeIcon from '@/components/ui/icon/EnergyGroupTypeIcon';

// components
import { useDatagridLocaleText } from '@/hooks/useDatagridLocaleText';

const EnergyGroupDataGrid = ({ energyGroups = [] }) => {
  const navigate = useNavigate();

  const localeText = useDatagridLocaleText();

  const portfolioGroups = energyGroups.filter(
    (group) => !group.type?.toLowerCase().includes('portfolio'),
  );

  const columns = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'DeepDive',
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <EnergyGroupTypeIcon type={params.row.type} />
              <span>{params.row.name}</span>
            </div>
          );
        },
        // valueGetter: (params) => params.row?.name ?? params.row?.Name ?? '',
      },
      // {
      //   field: 'type',
      //   headerName: 'Type',
      //   flex: 1,
      //   minWidth: 160,
      //   // valueGetter: (params) => params.row?.type ?? params.row?.Type ?? '',
      // },
      {
        field: 'initiativeCount',
        headerName: 'Igangværende initiativer',
        type: 'number',
        flex: 0.5,
        minWidth: 120,
        renderCell: (params) => {
          const count = params.row?.energyInitiatives?.length || 0;
          return <span>{count}</span>;
        },
      },
      {
        field: 'nodes',
        headerName: 'Antal målepunkter',
        type: 'number',
        flex: 0.5,
        minWidth: 120,
        renderCell: (params) => {
          const count = params.row?.energyTreeNodes?.length || 0;
          return <span>{count}</span>;
        },
      },
    ],
    [],
  );

  return (
    <DataGridPremium
      rows={portfolioGroups}
      density="compact"
      columns={columns}
      getRowId={(row) => row.energyGroupId}
      onRowClick={(params) => {
        navigate({
          to: `/$accountId/energyxplorer/deepdive/${params.row.energyGroupId}/consumption-overview`,
        });
      }}
      disableRowSelectionOnClick
      localeText={{
        ...localeText,
        noRowsLabel: 'Ingen DeepDives fundet',
      }}
      sx={{
        '& .MuiDataGrid-row:hover': {
          cursor: 'pointer',
        },
      }}
    />
  );
};

export default EnergyGroupDataGrid;
